import { createAPIService } from './api.service';

export const FORM_TEMPLATE_CONFIG_ENDPOINT =
  '/config/api/configurations/templates-forms';

const service = createAPIService(FORM_TEMPLATE_CONFIG_ENDPOINT);

service.getFormConfig = async id => (await service.get(`/${id}`)).data;

export default service;
